import { FhSideBarServiceConfigInterface } from '../../interfaces/fh-side-bar-service-config/fh-side-bar-service-config-interface';
import { FhSideBarHeaderConfigModel } from '../fh-side-bar-header-config/fh-side-bar-header-config-model';
import { FhSideBarVisibleEmitterModel } from '../fh-side-bar-visible-emitter/fh-side-bar-visible-emitter-model';

export class FhSideBarServiceConfigModel implements FhSideBarServiceConfigInterface {
  visibleChangedEmitter: FhSideBarVisibleEmitterModel = new FhSideBarVisibleEmitterModel();
  widthChangedEmitter: string = '';
  configHeaderEmitter: FhSideBarHeaderConfigModel = new FhSideBarHeaderConfigModel();

  constructor(init?: Partial<FhSideBarServiceConfigModel>) {
    Object.assign(this, init);
  }
}
